import HeaderAlerts from '../headerAlerts';
import LayoutCheckbox from '../forms/layoutCheckbox';
import LayoutSelect from '../forms/layoutSelect';
import Medusa from 'medusajs';
import Modal from './modal';
import PropTypes from 'prop-types';
import React from 'react';
import events from 'lib/events';
import session from 'services/sessionService';
import {languages, allowTranslations} from 'helpers/languageHelper';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import NavBarAccountMenu from './NavBarAccountMenu';

class NavBar extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);
    let branches = session.getMyBranches();

    this.state = {
      showBranchesModal: false,
      selectedBranch: branches.length > 0 ? branches[0].id : null,
    };
  }

  componentDidMount() {
    let user = session.getUser();
    let apps = user.apps || [];

    try {
      window.insertAppSelector(window.idmAddress, apps, window.appName, null, null, false, true, this.props.intl.locale, user.region, user.firstName, user.lastName, user.email);
    } catch (err) {
      // Log error rather than breaking the component
      console.error(err);
    }

    this.unsub = events.subscribe('locale.changed', () => setTimeout(() => {
      let user = session.getUser();
      let apps = user.apps || [];

      document.querySelector('#app-select').innerHTML = '';
      try {
        window.insertAppSelector(window.idmAddress, apps, window.appName, null, null, false, true, this.props.intl.locale, user.region, user.firstName, user.lastName, user.email);
      } catch (err) {
        // Log error rather than breaking the component
        console.error(err);
      }
    }, 0));
  }


  //Avoid re-render navbar after every click within website window
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.intl !== nextProps.intl ||
    this.props.intl && nextProps.intl && this.props.intl.locale !== nextProps.intl.locale ||
    this.state.showBranchesModal !== nextState.showBranchesModal ||
    this.state.selectedBranch !== nextState.selectedBranch;
  }

  componentWillUnmount() {
    if (this.unsub && this.unsub.remove) {
      this.unsub.remove();
    }
  }

  closeBranchModal = () => {
    this.setState({
      showBranchesModal: false,
    });
  };

  downgradeToBranch = (branchID) => {
    return () => {
      session.downgrade(branchID);
      this.closeBranchModal();
    };
  };

  openBranchModal = () => {
    this.setState({
      showBranchesModal: true,
    });
  };

  selectBranch = (e) => {
    this.setState({
      selectedBranch: e.value,
    });
  };

  render() {
    let user = session.getUser();
    let formatMessage = this.props.intl.formatMessage;
    let branches = session.getMyBranches();
    let branchKeys = branches.map(x => x.id);
    let branchValues = branches.map(x => x.name);

    branchKeys.unshift('');
    branchValues.unshift(formatMessage({id: 'general.select.store'}));
    return <nav id='nav-bar'
                className='hidden-print'>
      <div className='navbar-header'>
        <a className='navbar-brand'
           href='#'>
          <img src='Content/img/logo.png'
               alt='Alex Logo'
               height='62'
               className='navbar-logo'/>
        </a>
      </div>
      <div className='nav-bar-margin-offset'>
        <div className='container'>
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <NavBarAccountMenu openBranchModal={this.openBranchModal} />
            </li>
            <li>
              <div id='app-select'
                   className='app-select-margins'/>
            </li>
            <li>
              <HeaderAlerts/>
            </li>
          </ul>
        </div>
      </div>
      {this.state.showBranchesModal ? <Modal onClose={this.closeBranchModal}>
        <div>
          <h2><FormattedMessage id="navbar.select.store.location"/>:</h2>
          <LayoutSelect keys={branchKeys}
                        options={branchValues}
                        editMode={true}
                        label='Stores'
                        dataKey='branchSelect'
                        dataChanged={this.selectBranch}
                        value={this.state.selectedBranch}/>
          <button onClick={this.downgradeToBranch(this.state.selectedBranch)}
                  className='btn btn-primary'
                  disabled={!this.state.selectedBranch}>
            <FormattedMessage id="general.downgrade"/>
          </button>
        </div>
      </Modal> : null}
    </nav>;
  }
}

export default injectIntl(NavBar);
